var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 691",
    width: 536,
    height: 181,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112,46)",
    d: "m0 0h1829l33 2 17 2 7 4 12 11 7 6 10 16 4 11 3 26v420l-2 31-4 15-8 14-9 10-7 6-11 7-12 5-8 1-82 1h-1698l-80-1-15-3-8-4-10-8-8-9-15-20-3-15-1-24v-419l1-29 2-9 6-11 9-12 12-12 13-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,228)",
    d: "m0 0h8l18 4 26 10 10 3 8-1 30-11 14-4 7-1h24l17 4 12 5 14 9 14 13 3 5-1 3-9 7-12 12-9 14-6 15-3 19 1 13 4 17 8 17 11 13 9 8 16 9 1 4-6 15-8 16-8 14-12 18-13 16-12 10-12 6-10 2-16-1-17-6-15-6-11-2h-12l-14 3-15 6-14 5-6 1h-14l-10-3-11-8-10-9-11-14-12-17-8-13-11-24-7-20-6-21-3-15-2-19v-16l3-24 5-16 9-19 9-13 11-11 12-9 15-7 19-5z",
    fill: "#FBFBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112,46)",
    d: "m0 0h1829l33 2 17 2 7 4 12 11 7 6 10 16 4 11 3 26v420l-2 31-4 15-8 14-9 10-7 6-11 7-12 5-8 1-82 1h-1698l-80-1-15-3-8-4-10-8-8-9-15-20-3-15-1-24v-419l1-29 2-9 6-11 9-12 12-12 13-8zm12 12-16 2-13 5-10 8-9 10-8 16-2 10-1 64v391l2 16 4 9 6 10 9 10 11 7 13 4 9 1h1847l15-2 14-7 12-11 6-8 5-10 2-12v-463l-2-11-6-12-9-11-10-8-11-5-9-2-11-1z",
    fill: "#D0D2D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,365)",
    d: "m0 0h25l13 4 10 7 10 10 7 12 5 14 2 13v22l-3 17-5 14-6 10-5 6-11 9-14 7-11 2h-19l-10-3-11-7-7-7-2-1 1 2v70l-1 1h-30l-1-1-1-171-1-28h29l1 4v17l12-12 13-8z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,365)",
    d: "m0 0h25l13 4 13 9 7 8 8 14 4 12 2 12v23l-3 18-6 15-7 10-6 7-13 9-9 4-11 2h-18l-11-3-11-7-8-8v72l-1 1h-26l-5-1-1-199 2-1 26 1 1 1 1 20 10-11 10-7 10-4z",
    fill: "#F9F9F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1951,47)",
    d: "m0 0h12l28 3 7 4 12 11 7 6 10 16 4 11 3 26v420l-2 31-4 15-8 14-9 10-7 6-11 7-12 5-8 1-82 1h-1698v-1h24l1-2h1638v-2l2-1h6v-2l-3-2 15 1 3 4-3 3h16v-2h3v-2l2-2-3-1-18-1v-1h-15l-10 1h-10v-1h-1624l-58-1v-1l1807-1 15-2 14-7 12-11 7-10 4-11 1-8v-463l-2-11-6-12-9-11-11-8-9-4-9-2-11-1-1589-1v-1l1527-1-7-2h-21l3 2h-27l-28-1-16-1-8-3h-5l-5-2v-1h23 2 32v1l-4 1 7 2 4 1h7l-7-3 2-2z",
    fill: "#B6B6B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(152,622)",
    d: "m0 0h1693v1l16-1h64v1l-31 1 5 1 3 3h-7v2h-3v2h-16l1-4-3-2-8-1-2 1v2l-8 1v2l2 1h-1642l-3-1-1 1h-7l4-1v-2h-7l-8-3-4-1-7 2-4 2 5 2v1h-16l-14-6 3-2-5-1z",
    fill: "#FBFBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1522,365)",
    d: "m0 0h28l15 4 9 5 9 7 8 9 7 12 4 12 3 20v7l-4 23-6 14-7 10-10 10-11 7-9 4-16 3h-19l-14-3-12-6-10-8-7-8-9-15-4-12-1-6v-30l3-13 8-16 7-9 10-10 11-6 11-4z",
    fill: "#F9F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(739,312)",
    d: "m0 0h38l3 7 9 29 12 36 12 38 12 36 15 48v3h-34l-8-26-9-30-1-1-63-1-2 9-14 49-5 1-29-1 3-10 18-56 14-43 10-34 12-36 5-16z",
    fill: "#F8F9F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(127,47)",
    d: "m0 0 1013 1v2h-7l-6 2-2-1v-2h-2l-1 3-1-2-7 1-13 1-2-1h-350l-35 1-7 2v-2l-3 1-1-1-1 2h-12v-2l-10 1h-11l-4 1-6-2-5 2-6-2-2 2-7-3-3 1-1 2-1-2h-5l-5 1-7-1-2 1h-15l3 2h-7v-3l-6 1-1 2h-3v1h-20l-1-2-6 1-3-1-7 2-17-1h-16l-4-2-7 1h-11l-3-1-1 2-3-2-13 1-6-2-2 2h-14-3-1-7l-3 1-6-1-4 1h-10l-1-1h-40l-32 1-18 1h40l6 1v1l-249 1-16 2-13 5-10 8-8 9-8 16-2 10-1 64v391l2 16 4 9 6 10 8 9 11 7 13 4 9 1 40 1v1l27 1v1l-29 1 1 2 10 4h13l-3-3 5-2 7-2h8l-2 2 6 2 7 1v2l5-1 3 3h-104l-15-3-8-4-10-8-8-9-15-20-3-15-1-24v-419l1-29 2-9 6-11 9-12 12-12 13-8 9-2h17z",
    fill: "#B6B7B6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1772,365)",
    d: "m0 0h30l10 3 10 6 11 11 7 12 4 12 2 21v15l-1 1h-95l5 16 5 10 7 7 11 5 7 2h23l15-3 10-3 2 6 3 11v5l-10 5-21 4-20 1-18-2-15-6-10-7-9-8-8-13-5-14-2-11v-22l3-15 5-13 7-12 9-10 9-7 11-5z",
    fill: "#F8F8F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1282,310)",
    d: "m0 0h25l15 3 15 5 1 3-6 19-2 5-2 1-15-7-12-2h-17l-11 4-8 6-5 9-1 8 4 10 5 6 11 7 17 8 16 8 12 7 9 8 7 11 4 10 1 5v19l-4 13-5 10-8 9-10 7-10 5-16 4-11 1h-16l-16-2-16-5-9-5 1-8 3-11 1-7 3-1 12 6 14 4 7 1h22l10-3 9-6 5-8 1-4v-14l-4-9-5-5-9-6-29-13-11-6-9-7-10-11-7-13-2-11 1-14 5-13 8-11 7-7 10-6 13-5z",
    fill: "#F9F9F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1411,332)",
    d: "m0 0 4 1-1 34h35v24h-35l1 3v73l2 8 2 5 3 1v2l7 2 11-1 5-1 1 2 1 11v11l-3 3-16 2h-12l-10-2-9-6-7-8-5-10-2-8-1-14v-72l-1-1h-19v-24h21l-1-3v-22z",
    fill: "#F8F8F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(152,622)",
    d: "m0 0h1693v1l16-1h64v1l-31 1 5 1 3 3h-7v2h-3v2h-16l1-4-3-2-8-1-2 1v2l-8 1v2l2 1h-14v-3l4-1h-58l-7 1h-18l-19 2-5-3v-1l19-1h-657l10 1 1 3-29-1-11-2h-78l-22 1-4 1h-33l-3-1-21-1h-78l-12 2-30 1-3 1-3-2 12-3h-338l25 1 1 2-10 1-101-1-9-1h-125l-10 1h-8l3 2-1 1h-10l-3-1-1 1h-7l4-1v-2h-7l-8-3-4-1-7 2-4 2 5 2v1h-16l-14-6 3-2-5-1z",
    fill: "#E9F0F3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(705,147)",
    d: "m0 0h27l11 2 10 4 8 6 6 7 4 9 2 11v17l-3 12-5 10-8 9-10 6-17 4h-36l-1-1v-94l1-1z",
    fill: "#F7F7F7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1526,388)",
    d: "m0 0h17l10 5 8 8 6 12 4 15 1 13-3 16-4 11-6 9-9 8-7 3-5 1h-8l-10-3-10-9-7-11-3-9-2-10v-18l4-16 6-11 9-10z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(927,390)",
    d: "m0 0h13l9 3 8 7 6 7 5 12 2 10v19l-4 15-5 10-9 9-8 4-4 1h-14l-10-4-10-9-5-8-2-7-1-9v-21l2-13 6-12 9-9 8-4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,390)",
    d: "m0 0h11l8 2 9 6 7 9 5 12 2 12v15l-4 17-5 10-5 5-8 6-8 3h-13l-11-4-10-9-6-11-2-13v-22l2-12 6-12 9-9 8-4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1688,365)",
    d: "m0 0h17l1 1v28l-2 2h-17l-7 3-8 7-5 8-3 9-1 6-1 80h-30l-1-1-1-140 1-1h27v24l5-5 6-9 8-7 8-4z",
    fill: "#F8F8F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1333,142)",
    d: "m0 0h15l1 1-1 101h-11l-2-1-1-7-12 8-4 1h-13l-8-3-6-5-7-12-2-10v-12l4-13 6-9 9-6 5-2h14l10 5h2v-19z",
    fill: "#F7F7F7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,173)",
    d: "m0 0h16l11 4 8 7 6 12 1 4v17l-3 10-7 9-7 6-10 3h-16l-11-4-7-7-6-12-2-10 1-12 5-12 9-10 8-4z",
    fill: "#F7F7F7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1145,173)",
    d: "m0 0h16l11 4 8 7 4 6 2 5 1 6v16l-3 10-6 8-8 7-10 3h-15l-10-3-8-7-6-11-2-6v-18l5-12 8-9 9-5z",
    fill: "#F6F6F6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1438,173)",
    d: "m0 0h16l11 4 8 7 6 11 1 4v19l-4 10-6 8-7 6-10 3h-16l-9-3-8-7-6-10-2-9v-14l4-12 6-8 6-5 6-3z",
    fill: "#F6F6F6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(463,137)",
    d: "m0 0h6v11l-4 20-5 12-6 12-10 12-13 10-14 7-19 4h-6v-15l3-15 8-17 8-11 9-10 13-9 15-7z",
    fill: "#F9F9F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(922,173)",
    d: "m0 0h7l3 5 13 45 1 2 8-36 4-15h16l1 2-9 27-9 28-4 11-2 2h-10l-4-2-8-27-4-17v-3h-2l-3 14-6 20-5 13-2 2h-11l-3-2-13-44-7-22v-2h17l2 7 9 40 1 4 3-8 6-22 7-20z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(217,631)",
    d: "m0 0h1627l10 1 1 2h-1662v-1h24z",
    fill: "#5B5B5B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1224,173)",
    d: "m0 0h19l7 3 5 5 5 10 1 8v45h-11l-3-3-1-2-4 2-10 4h-14l-7-4-4-5-3-7v-9l4-9 5-5 12-6 19-3h2l-4-8-5-4h-12l-11 4h-3l-1-2v-9l5-3z",
    fill: "#F6F6F6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1688,142)",
    d: "m0 0h15v40l10-7 4-2h14l8 4 6 8 3 10v48l-1 1h-16l-1-50-3-5-4-2h-10l-8 7-1 2-1 48h-15z",
    fill: "#F7F8F7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1798,172)",
    d: "m0 0h8l9 2 6 4 6 7 4 10 1 17-1 1h-47l7 14 6 4 5 1 17-1 8-1 1 5-2 7-6 2-18 1-13-2-7-4-6-7-5-10-1-4v-17l4-11 7-10 9-6z",
    fill: "#F7F7F7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,159)",
    d: "m0 0 17 1 9 4 6 5 5 8 2 7v20l-3 10-6 8-7 6-7 3-6 1h-17v-71z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,173)",
    d: "m0 0 12 1 1 9 9-7 7-3h14l8 4 7 9 2 6 1 51-1 1h-15l-1-1-1-47-3-6-4-3-8-1-6 3-4 5-2 6-1 43-1 1h-14l-1-1v-69z",
    fill: "#F4F4F4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1532,173)",
    d: "m0 0h13l7 3 5 5 4 6 2 6 1 50-1 1h-15l-1-1-1-48-4-6-6-3-8 1-7 6-2 5-1 45-1 1h-15l-1-69 1-1h13l2 8 10-7z",
    fill: "#F7F7F7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(756,343)",
    d: "m0 0 3 3 7 28 13 41 3 10-1 3-49-1 1-8 9-28 10-36 2-11z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1776,387)",
    d: "m0 0h16l9 3 8 8 5 11 2 9v5l-3 1h-62l1-9 8-16 7-8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(159,621)",
    d: "m0 0h1762v1l-60 1-10 1h-10v-1h-1624l-58-1z",
    fill: "#B6B6B5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1648,157)",
    d: "m0 0 2 1-1 16h17v11l-1 1h-16l1 30 1 14 14 2 1 1v11h-22l-4-2-5-8-1-5v-43h-8l-3-1v-10l2-1h9v-11l2-3z",
    fill: "#F4F5F4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1080,142)",
    d: "m0 0h15l2 1v100l-1 1h-15l-1-1z",
    fill: "#F3F3F3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(64,552)",
    d: "m0 0h1l2 23 4 13 7 11 8 9 11 7 13 4 9 1 40 1v1l27 1v1l-29 1 1 2 10 4h13l-3-3 5-2 7-2h8l-2 2 6 2 7 1v2l5-1 3 3h-104l-15-3-8-4-10-8-8-9-9-12v-5-3l-1-5 3-2v-9l-2-1z",
    fill: "#C7C9C8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820,184)",
    d: "m0 0h9l6 4 5 6 2 7v16l-4 9-5 5-5 3h-7l-7-4-6-8-2-6v-13l4-10 6-7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1441,184)",
    d: "m0 0h10l8 7 3 5 1 4v15l-3 10-6 7-4 2h-8l-7-4-6-8-1-4v-17l4-10 7-6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,184)",
    d: "m0 0h8l5 3 5 6 3 7 1 5v7l-3 11-5 7-8 4-8-1-8-7-4-8-1-5v-7l4-13 4-5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1150,48)",
    d: "m0 0h635l-1 2-392 1h-240z",
    fill: "#B6B6B5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1314,184)",
    d: "m0 0 7 1 7 5 4 7 1 3v17l-4 9-8 6-2 1h-7l-6-4-6-7-2-7v-10l3-10 5-7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(62,188)",
    d: "m0 0h1l1 132 1 4h-2v159l-2 4-1-8h-1l-1-23v-252h1l1 12 1-4v-18z",
    fill: "#C5C7C6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1966,620)",
    d: "m0 0h15l1 2-14 1-3 1 4 1v3h-2l-1 2v-2h-4l-1 2-4 1 16 1v1l-82 1h-36l-1-2 2-1v-2l2-1h6v-2l-3-2 15 1 3 4-3 3h16v-2h3v-2l2-2-3-1-18-1v-1l45-1v-1z",
    fill: "#C4C6C5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,52)",
    d: "m0 0m-126-1 9 2 12-1 2 2 5-1h15 3 10v1l28 1 7-2 3 1 5-1 1 2h6v-1l14-1h3l5 1-4 3h-270v-1l19-2h13l31-1h33l1 1h13l2-1 7 1 3-1 5 1 1-2 2 2 2-1h13z",
    fill: "#C3C5C4"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1236,209)",
    d: "m0 0h7l2 1 1 3v7l-3 7-6 5-4 2h-6l-6-5-2-5 1-6 6-5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1733,46)",
    d: "m0 0h208l10 1v1l-99 1-1 1 6 2 1 2h-8l-4-1-7-1-3-3h-25l-2 1v-2h-24l-12 1-84-1v-1z",
    fill: "#CCCECD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1799,183)",
    d: "m0 0h6l6 4 4 5 3 8-10 1h-23l-1-2 6-10 6-5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(65,596)",
    d: "m0 0 4 1 6 7 4 6v2l16 8 4 1v2h5l2 2h2l-1 3 7 2h3 9l2 2-15 1-15-3-8-4-10-8-8-9-7-10z",
    fill: "#B7B7B6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1862,622)",
    d: "m0 0h63v1l-31 1 5 1 3 3h-7v2h-3v2h-16l1-4-3-2-13-2z",
    fill: "#F2F6F7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(152,622)",
    d: "m0 0h43v2l-11 2-5 3 5 2v1h-16l-14-6 3-2-5-1z",
    fill: "#EDF3F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(377,53)",
    d: "m0 0h40v1l-11 1h5l1 2h-91v-1l19-2h13z",
    fill: "#C5C7C6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1733,46)",
    d: "m0 0h66l10 1v1h-24l-12 1-84-1v-1z",
    fill: "#D4D5D4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1861,624)",
    d: "m0 0 15 1 3 4-2 1v3h-23l2-4 2-1h6v-2z",
    fill: "#C7C9C8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1809,47)",
    d: "m0 0h56v1l-13 1-1 1 6 2 1 2h-8l-4-1-7-1-3-3h-25l-2 1z",
    fill: "#C5C7C6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1884,624)",
    d: "m0 0h10l5 1 3 3h-7v2h-3v2h-16l1-3 8-3z",
    fill: "#FCFCFC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(157,624)",
    d: "m0 0h10l4 2 8 3 5 2v1h-16l-14-6z",
    fill: "#FCFCFC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1872,53)",
    d: "m0 0h22l6 1v2h19v1h-45l-3-3z",
    fill: "#C6C8C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,52)",
    d: "m0 0m-37 1 5 1 5-1 1 2h6v-1l14-1h3l5 1-4 3h-41l1-2z",
    fill: "#C5C6C5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(58,505)",
    d: "m0 0 3 2 1 5h1v18l-2-2v-4h-3z",
    fill: "#C4C6C5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(570,627)",
    d: "m0 0h24l1 2-3 1h-16l-11-1v-1z",
    fill: "#EAF1F4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,628)",
    d: "m0 0 15 1 3 2-1 1h-10l-3-1-1 1h-7l4-1z",
    fill: "#ECF1F3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(69,604)",
    d: "m0 0 4 2 2 4h2l7 8-1 3-8-8z",
    fill: "#C7C9C8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,621)",
    d: "m0 0 7 2 2 3 8 1 2 4-6-1-8-4z",
    fill: "#C8CAC9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,52)",
    d: "m0 0m-9 1 5 1 4-1 2 2-4 2h-5v-1l-13-1v-1z",
    fill: "#C3C5C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1876,624)",
    d: "m0 0h8l3 2-4 2-9-1 2-1z",
    fill: "#E9EFF2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1872,53)",
    d: "m0 0 9 1 1 2-2 1h-6l-3-3z",
    fill: "#C4C6C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.c5a707cb300abcffac2419fac4bb8802.svg";
export { ForwardRef as ReactComponent };